import bubble from "./bubble.gif"
import './AboutPage.css';
import { ReactComponent as Icon1 } from './svg/python-svgrepo-com.svg';
import { ReactComponent as Icon2 } from './svg/react-svgrepo-com.svg';
import { Link } from "react-router-dom";

export default function AboutPage() {

  return (

    <div className="App">

        <div className = "home-page-container">
          
    
          <div className = "green-line-bottom"> 

            <div className = "link-container">
                  <heading className = "header-avry-5"> About Me </heading>

              </div> 

         
          </div>
              <div className="container-gif">
                               <img className = "gif" src={bubble} alt="rainbowgif" />
                                          <div className="icon-item">
                                              <div className = "flex-icon"> 
                                                           <Icon1 className="icon-img" title="Python" />
                                                   <p style ={{fontSize:18}}className="icon-label">Python</p>

                                                  <p className = "p-space"></p>
                                          
                                                   <Icon2 className="icon-img" title="React" />
                                                   <p style ={{fontSize:18}}className="icon-label">React</p>
                                            
                                                
                                               
                                               </div>
                                              </div>
                                                  
              </div>
       
          <div className="container-carousel">
       
         
             
              <p className="paragraph-about-me-3"> I am a recent graduate from California State University Dominguez Hills (CSUDH), 
                and I love software engineering. It makes me happy to be solving peoples problems and 
                improving lives through software. 
              </p>
                <p className="paragraph-about-me-3"> 
                During high school I enjoyed playing video games and exploring many techniques to get better. My Favorite game is Halo 3. I loved
                the multiplayer aspect and the forge mode. This led to my Mom telling me to focus on school more because I was obsessed with the game. I also enjoyed playing golf as I made it to
                CIF in high school in 2nd place. At the end of my senior year is where I started to get introduced to programming by my aunt.
              </p>
                
            
                <p className = "paragraph-about-me-3">
                     <p style = {{fontSize:"1.3rem"}}className="header-avry-6"> View My Resume: <a  style = {{ color: "#1bbb75", textDecoration: "underline", textDecorationColor: "green" }}href="/Resume.pdf" target="_blank" rel="noopener noreferrer"> Resume.pdf</a></p>
                      <header className = "header-avry-6">Professional History: <Link style = {{ color: "#1bbb75", textDecoration: "underline", textDecorationColor: "green" }}sto = "/experience" > ExperiencePage</Link></header>
                 
                 
                   <Link to = "https://www.amateurgolf.com/">AmateurGolf.com</Link> - Software Developer - (February 2026 - Current)
                
                </p>

                    <p className = "paragraph-about-me-3">
                       
                   <Link to = "https://jewelryexchange.com/">JewelryExchange.com</Link> - Software Web Developer - Golden West Diamond Company (October 2020 - January 2026)
                </p>

                 <p className = "paragraph-about-me-3">
                        <Link to = "https://socalfurs.com/">Socalfurs.com</Link> | <Link to = "/socalfurs"style = {{ color: "#1bbb75", textDecoration: "underline", textDecorationColor: "green" }}>Project Details</Link> - Lead Software Dev - Community Website Platform (November 2024 - Current)
                </p>

                   <p className = "paragraph-about-me-3">
                        <Link to = "https://www.csudh.edu/">California State Dominguez Hills</Link> - Computer Sceince Tutor TLTC ( August 2025 - Decmeber 2025)
                </p>


               

                       <p className = "paragraph-about-me-3">
                           
                         <header className = "header-avry-6">Education</header>
                         
                       B.S, Bachelors of Science, Computer Science - Decmeber 2025, California State Dominguez Hills
                </p>
                    
                   <p className = "paragraph-about-me-3">
                      A.A, Associates of Arts, Liberal Arts - May 2023, Irvine Valley College
                </p>

             

                                  <div className = "container-gif">
                 
                         <p className = "paragraph-about-me-3">
                             <header className = "header-avry-6">Projects: <Link to = "/projects"style = {{ color: "#1bbb75", textDecoration: "underline", textDecorationColor: "green" }}>Project List</Link></header>
                              
                      <a href = "https://avryjackson.me/projects">Campus Navigation </a>- CSC 493 - Software Engineering - (Python & React)
                      
                </p>
                     <p className = "paragraph-about-me-3">
                     <a href =  "https://avryjackson.me/projects">Tutor Tracking</a> - TLTC Tutor - (Python & React)
                      
                </p>
                  <p className = "paragraph-about-me-3">
                     <a href =  "https://avryjackson.me/projects">Auto deployment Website Script</a> - Website Auto Uploader - (Python)
                      
                </p>
            

                  </div>

                   <p className = "paragraph-about-me-3">
                        <header className = "header-avry-6">Hobbies</header>
                </p>


                   <p className = "paragraph-about-me-3">
                      <strong style = {{ color: "#1bbb75", textDecoration: "None", textDecorationColor: "green" }}> Raves & Concerts</strong> - I really enjoy listening to music and espsecially dancing
                      to a super fun rhythm. I sometimes go out with friends when I have the time or by myself to listen to
                      artsits that I enjoy or find.
                </p>


                   <p className = "paragraph-about-me-3">
                      <strong style = {{ color: "#1bbb75", textDecoration: "None", textDecorationColor: "green" }}> Runnning</strong> - Running has been a good way to get myself outside and see the
                      sun and to keep me healthy. I enjoy cardio realted activites.
                </p>

                      <p className = "paragraph-about-me-3">
                      <strong style = {{ color: "#1bbb75", textDecoration: "None", textDecorationColor: "green" }}> DDR - Dance Dance Revolution</strong> - I've played this game ever since I was 
                      young. I have a couple of world records on it. When I go to an arcade, it is the only game I ever play
                      because its always been enjoyable to step with the beat.
                </p>
                 <div className = "container-gif">
                             
                               
                         <p className = "paragraph-about-me-3">
                         <header className = "header-avry-6">Contact Info</header>
                      Email: <a style = {{ color: "#1bbb75", textDecoration: "underline", textDecorationColor: "green" }}href="mailto:avry.jackson@hotmail.com">avry.jackson@hotmail.com</a>
                      
                </p>

                      <p className = "paragraph-about-me-3">
                      Linkedin: <a style = {{ color: "#1bbb75", textDecoration: "underline", textDecorationColor: "green" }}href = "https://www.linkedin.com/in/avry-jackson-886529265/">Profile</a>
                      
                </p>
                   <p className = "paragraph-about-me-3">
                      Phone: 714-306-9542
                      
                </p>

                    </div>        
              {/* End of div for about me */}
          
          </div>
        {/* Home-page-container div */}
        </div>

    {/* End of entire div */}
    </div>
  );
}
